import React from 'react';
import Inicio from "../images/Inicio.jpg"
import logoCafam from "../images/logoCafam.png"

export const Header = () => {

    return (
        <div id='ContainerHeader'>
            <div className='containerLogo'>
                <img src={logoCafam} className="logoimg" alt="" />
                <div className='detalles_1'></div>
            </div>
            <div className='header'>
                <div className='parteIzquierdaHeader'>
                    <div>
                        <h2>Canal Ético de Denuncias</h2>
                        <div className='detalles'></div>
                    </div>
                </div>
                <div className='ParteDerechaHeader'>
                    <img src={Inicio} class="imgheader" alt="" />
                </div>
            </div>
        </div>

    );
};

export default Header;